import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';

import {
    loaiYeuCauGetAllAction,
    deleteLoaiYeuCauAction,
    filterListLoaiYeuCau
} from '@store/reducers/loaiyeucau';

import { createUrlWithParam } from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { objectShowNumber, messageToast } from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { Dropdown } from 'react-bootstrap';

const LoaiYeuCau = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const valueSearch = useSelector((state) => state.search.valueSearch);
    const listLoaiYeuCau = useSelector((state) => state.loaiyeucau.listLoaiYeuCau);
    const totalItems = listLoaiYeuCau?.length || 0;

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // Load dữ liệu
    const fetchData = useCallback(async () => {
        const result = await dispatch(loaiYeuCauGetAllAction());
        return result;
    }, [dispatch]);

    // Lấy từ URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const pageParam = parseInt(params.get('page') || 1, 10);
        const sizeParam = parseInt(params.get('size') || 20, 10);
        const searchParam = params.get('search') || '';

        if (pageParam !== page) setPage(pageParam);
        if (sizeParam !== pageSize) setPageSize(sizeParam);
        if (searchParam !== search) setSearch(searchParam);

        fetchData();
    }, [location.search, fetchData]);

    // Khi search global thay đổi
    useEffect(() => {
        if (valueSearch !== search) {
            setSearch(valueSearch);
            setPage(1);

            history.replace(
                createUrlWithParam(URI_INTERNAL.LOAIYEUCAU_PATH, {
                    page: 1,
                    size: pageSize,
                    search: valueSearch
                })
            );
        }
    }, [valueSearch, pageSize, search, history]);

    // Phân trang FE
    const pagedData = listLoaiYeuCau.slice((page - 1) * pageSize, page * pageSize);

    const changePage = (number) => {
        setPage(number);
        history.replace(createUrlWithParam(URI_INTERNAL.LOAIYEUCAU_PATH, {
            page: number,
            size: pageSize,
            search
        }));
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value, 10);
        setPageSize(newSize);
        setPage(1);
    };

    // Delete
    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;

        try {
            const result = await dispatch(deleteLoaiYeuCauAction(idWantDelete));

            if (result.payload?.errors) {
                toast.error(result.payload.errors.content[0]);
            } else if (result.payload === 200) {
                await dispatch(filterListLoaiYeuCau(idWantDelete));
                toast.success(messageToast.messageToastDeleteSuccess);
                history.replace(URI_INTERNAL.LOAIYEUCAU_PATH);
            }
        } catch (error) {
            toast.error(messageToast.messageToastTryCatch);
        }

        setOpenConfirmDeleteModal(false);
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Danh sách Loại yêu cầu</h3>
                        </div>

                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <form className="form-inline">
                                    <label className="mr-2">Hiển thị :</label>
                                    <select className="form-control" value={pageSize} onChange={onChangeShowNumber}>
                                        {objectShowNumber.map((item, key) => (
                                            <option key={key} value={item.value}>{item.text}</option>
                                        ))}
                                    </select>
                                </form>

                                <NavLink className="nav-link-reject nav-link" to={URI_INTERNAL.LOAIYEUCAU_CREATE_PATH}>
                                    <button type="button" className="btn btn-info">
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>

                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Tên Loại yêu cầu</th>
                                        <th>Chức năng</th>
                                    </tr>
                                </thead>

                                {pagedData && pagedData.length > 0 ? (
                                    <tbody>
                                        {pagedData.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1 + (page - 1) * pageSize}</td>
                                                <td>{item.name}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                    <div className="d-flex justify-content-center">
                                                        <Dropdown align="end">
                                                            <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                id={`loaiyeucau-actions-${item.id}`}
                                                                className="d-inline-flex align-items-center justify-content-center"
                                                                style={{ minWidth: 92, whiteSpace: 'nowrap' }}
                                                            >
                                                                Thao tác
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item
                                                                    as={NavLink}
                                                                    to={createUrlWithParam(URI_INTERNAL.LOAIYEUCAU_EDIT_PATH, { id: item.id })}
                                                                    exact
                                                                >
                                                                    Sửa
                                                                </Dropdown.Item>

                                                                <Dropdown.Divider />

                                                                <Dropdown.Item
                                                                    as="button"
                                                                    className="w-100 text-left text-danger"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        deleteAction(item.id, item.name);
                                                                    }}
                                                                >
                                                                    Xóa
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr className="txt-center">
                                            <td colSpan="3">Không có dữ liệu</td>
                                        </tr>
                                    </tbody>
                                )}
                            </Table>

                            <div className="dataTables_paginate paging_simple_numbers">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm no-margin pull-right"
                                    activePage={page}
                                    itemsCountPerPage={Number(pageSize)}
                                    totalItemsCount={totalItems}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                />
                            </div>

                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={acceptDelete}
                                handleCancel={cancelDelete}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoaiYeuCau;